import { createFileRoute } from '@tanstack/react-router'

import { FreeBankrollRoute } from '@/pages/promotion/route-entries/free-bankroll'
import { buildPageTitle } from '@/utils/seo'

export const Route = createFileRoute('/_layout/promotion/free-bankroll/')({
  component: FreeBankrollRoute,
  head: () => {
    return {
      meta: [
        {
          title: buildPageTitle('Free Bankroll'),
        },
      ],
    }
  },
})
